import { useState, useEffect } from "react";
import { toast } from "react-hot-toast";
import { FaFaceFrown } from "react-icons/fa6";
import { PiHandGrabbingLight, PiHand } from "react-icons/pi";

function Footer() {
    const [isHovered, setIsHovered] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const mediaQuery = window.matchMedia("(pointer: coarse)");

        setIsMobile(mediaQuery.matches);

        const handleMediaQueryChange = (e) => {
            setIsMobile(e.matches);
        };

        mediaQuery.addEventListener("change", handleMediaQueryChange);

        return () => {
            mediaQuery.removeEventListener("change", handleMediaQueryChange);
        };
    }, []);

    const handleClick = () => {
        toast.dismiss();
        toast("Well there shouldn't be any", {
            icon: <FaFaceFrown className="text-red-500 text-xl animate-pulse" />,
            duration: 1300,
            style: {
                background: "rgba(2, 6, 23, 0.92)",
                color: "#ffffff",
                border: "1px solid rgba(255,255,255,0.10)",
                borderRadius: "18px",
                padding: "14px 16px",
                backdropFilter: "blur(14px)",
                boxShadow: "0 10px 35px rgba(0,0,0,0.35)",
            },
        });
    };

    return (
        <footer className="w-full flex justify-end p-6 mt-auto relative z-0 overflow-hidden border-t border-white/10">
            {!isMobile && (
                <button
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    onClick={handleClick}
                    className={`hijack-target flex items-center gap-2 rounded-full border border-red-500/20 bg-red-500/10 px-4 py-2 text-sm font-bold text-red-500 backdrop-blur-md transition-all duration-300 ease-out hover:bg-red-500/20 hover:shadow-[0_0_15px_rgba(239,68,68,0.4)] ${isHovered ? "scale-105" : "scale-100"
                        }`}
                >
                    {isHovered ? (
                        <PiHandGrabbingLight className="h-5 w-5 animate-pulse" />
                    ) : (
                        <PiHand className="h-5 w-5" />
                    )}
                    <span>Got any complaints? Click on me</span>
                </button>
            )}
        </footer>
    );
}

export default Footer;